<template>
  <div class="inner_ad_div" style="margin-top: 40px;">
    <eo-ad-zone
      data-apikey="TPDM7M9IKdMOwSkFi9lBI2knVhZSQUpYueoZx9Zu"
      data-format="desktop"
    >
    </eo-ad-zone>
  </div>
</template>
<script>
export default {
  name: "AdBanner",
  data: () => ({
    adZone: null
  }),
  methods: {
    setAdZoneFormat() {
      const width = window.innerWidth;
      // Mobile-Wert nach Belieben anpassen.
      const mobileThreshold = 960;
      if (width <= mobileThreshold) {
        this.adZone.setAttribute("data-format", "mobile");
      } else {
        this.adZone.setAttribute("data-format", "desktop");
      }
    }
  },
  async mounted() {
    this.adZone = document.querySelector("eo-ad-zone");

    window.addEventListener("resize", this.setAdZoneFormat);
    this.setAdZoneFormat();
  }
};
</script>
